/**
 * Support — ticket list and case status.
 * Inspired by: Fresha support, Square dispute flow.
 */
import { PageHead } from "../components/PageHead";
import { LifeBuoy, MessageSquare, Clock, CheckCircle2, AlertTriangle, ChevronRight } from "lucide-react";
import { supportTickets as ticketsData } from "@evocha/mock-data";

interface Ticket {
  id: string;
  agent: string;
  subject: string;
  status: "open" | "investigating" | "resolved";
  time: string;
}

const statusConfig: Record<Ticket["status"], { bg: string; color: string; icon: React.ReactNode }> = {
  open: { bg: "var(--ev-blue-100)", color: "var(--ev-blue-600)", icon: <MessageSquare size={14} /> },
  investigating: { bg: "var(--ev-amber-100)", color: "var(--ev-amber-600)", icon: <AlertTriangle size={14} /> },
  resolved: { bg: "var(--ev-mint-100)", color: "var(--ev-mint-600)", icon: <CheckCircle2 size={14} /> },
};

export function Support() {
  return (
    <>
      <PageHead
        title="Support"
        description="Agent tickets, dispute cases, and support operations."
      />

      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        {ticketsData.map((t) => (
          <div key={t.id} className="admin-card support-ticket" style={{ padding: 20, display: "flex", gap: 16, alignItems: "center" }}>
            <div className="support-ticket-icon" style={{ width: 40, height: 40, borderRadius: "var(--ev-radius-md)", background: statusConfig[t.status].bg, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
              <span style={{ color: statusConfig[t.status].color }}>{statusConfig[t.status].icon}</span>
            </div>
            <div className="support-ticket-main" style={{ flex: 1, minWidth: 0 }}>
              <div className="support-ticket-head" style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 4 }}>
                <span className="support-ticket-id ev-body-mono">{t.id}</span>
                <span className="support-ticket-subject ev-body-semibold">{t.subject}</span>
              </div>
              <div className="support-ticket-meta ev-body-micro muted">
                Agent: {t.agent} · {t.time}
              </div>
            </div>
            <span className="admin-status support-ticket-status" style={{ background: statusConfig[t.status].bg, color: statusConfig[t.status].color }}>
              {statusConfig[t.status].icon}
              <span>{t.status}</span>
            </span>
            <ChevronRight className="support-ticket-chevron" size={16} style={{ color: "var(--ev-slate-400)" }} />
          </div>
        ))}
      </div>
    </>
  );
}
